import {useMutation} from 'plugins/apollo'
import {gql} from 'graphql-tag'

export const newsletterMutation = [
	gql`
		mutation subscribeToNewsletter($subscriber: NewsletterInput) {
			subscribeToNewsletter(subscriber: $subscriber)
		}
	`,
	{
		name: 'subscribeToNewsletter',
		props: ({subscribeToNewsletter}) => ({
			subscribeToNewsletter: subscriber =>
				subscribeToNewsletter({
					variables: {
						subscriber,
					},
				}),
		}),
	},
] as const

const SUBSCRIBE_TO_NEWSLETTER_MUTATION = gql`
	mutation subscribeToNewsletter($subscriber: NewsletterInput) {
		subscribeToNewsletter(subscriber: $subscriber)
	}
`

export const useSubscribeToNewsletter = () => {
	const [mutate] = useMutation(SUBSCRIBE_TO_NEWSLETTER_MUTATION)
	return (subscriber: {
		email: string
		firstName: string
		lastName: string
		lang: string
	}) => {
		return mutate({
			variables: {
				subscriber,
			},
		})
	}
}
